/* eslint-disable react/no-unused-prop-types */
/* eslint-disable no-undef */
/* eslint-disable react/no-unused-prop-types */
/* eslint-disable react/require-default-props */
import React from 'react';
import { Backdrop, makeStyles } from '@material-ui/core';
import { Container } from './styles';

interface Props {
  position: string;
  openeded: boolean;
  setOpened: Function;
  widget: JSX.Element;
}

const useStyles = makeStyles((theme: any) => ({
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: '#f8f8f8',
  },
}));

const GlobalModal: React.FC<Props> = ({
  openeded, widget, position,
}) => {
  const classes = useStyles();
  return (
    <Backdrop
      className={classes.backdrop}
      open={openeded}
    >
      {/* @ts-ignore */}
      <Container position={position}>
        {widget}
      </Container>
    </Backdrop>
  );
};
export default GlobalModal;
